<template>
    <div class="specialVideos" v-if="special && JSON.stringify(special)!='{}'">
        <div class="features" v-if="special.harvardVideos && special.harvardVideos.length!=0">
            <div class="module_title" :class="baseParams.noLine? 'module_title2':''">
                <span class="title">{{special.topicTitle}}：{{special.topicName}}</span>
                <span class="tag" v-if="!baseParams.nowWatch && special.tag=='最新'"><img src="./../../../assets/images/activity/harvard/hot.png" alt=""></span>
                <span class="nowWatch" @click="playVideo(special.harvardVideos[0].fnVideoId,1)" v-if="!baseParams.nowWatch">立即观看</span>
                <span class="more" @click="watchAll(special.topicId)" v-else>查看全部<van-icon name="arrow" /></span>
            </div>
            <div class="specialList">
                <mySwiper :slidesNum="2.5" :spaceBetweenNum="9" :swipeid="'special_list_swiper'"  :loop="false" style="overflow:hidden;width:auto;" :style="baseParams.isIndex?{'padding-left':'9px'}:{'padding-left':'18px'}">
                    <div @click="playVideo(item.fnVideoId,2,special.tag,item,index)" v-for="(item,index) in special.harvardVideos" :key="item.id" class="swiper-slide" slot="swiper-con">
                        <div class="imgCon" v-lazy:background-image="item.videoImg">
                            <div class="videoLoading" v-if="item.fnVideoId==curPlayVideoId">播放中···</div>
                        </div>
                        <div class="tit" :class="item.fnVideoId==curPlayVideoId?'tit2':''">{{item.videoTitle}}</div>
                    </div>
                </mySwiper>
            </div>
            <div class="art_read_collection" v-if="!baseParams.collection" :style="baseParams.isIndex?{'padding-left':'12px'}:{'padding-left':'18px'}">
                <span>{{fomatterNum(special.views)}}播放</span>
                <span>{{fomatterNum(special.likes)}}点赞</span>
            </div>
        </div>
        <div class="features nextUpdate" v-else>
            <div class="module_title">
                <span class="title">{{special.topicTitle}}：{{special.topicName}}</span>
                <span class="tag tagNext" v-if="!baseParams.nowWatch"><img src="./../../../assets/images/activity/harvard/next.png" alt=""></span>
            </div>
            <div class="banner" @click="gioClick"><img :src="special.img" alt=""></div>
        </div>
    </div>
</template>

<style lang="less" scoped>
@import './../../../assets/less/harvard.less';
.specialVideos{
    .features{
        // padding: 0 12px;
        background: @color255;
        border-bottom: 0.26667rem solid #F8F8F8;
        // 标题
        >.module_title{
            padding:12px 18px;
            border-bottom: 0.5px solid #CCCCCC;
            .title{
                font-size: @fontSize16;
                font-weight: bold;
                color: @color51;
            }
            .tag{
                padding-left: 5px;
                width: 31px;
                height: 14px;
                display: inline-block;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            .tagNext{
                width: 65px;
            }
            .nowWatch{
                float: right;
                display: inline-block;
                width:80px;
                height:22px;
                background:linear-gradient(270deg,rgba(212,164,55,1) 0%,rgba(229,191,93,1) 100%);
                border-radius:11px;
                font-size: @fontSize12;
                font-weight: 500;
                color: @color255;
                line-height: 22px;
                text-align: center;
            }
            .more {
                float: right;
                line-height: 0.52rem;
                color: @color153;
                padding-top: 2px;
                .van-icon {
                    height: 12px;
                    color: @color153;
                    display: block;
                    float:right;
                    position: relative;
                    top:0.08rem;
                    font-size:@indexFontSize12;
                }
            }
        }
        .module_title2{
            border-bottom: 0;
            padding-top: 19px;
            padding-bottom: 0;
        }
        // 收藏点赞量
        .art_read_collection{
            padding: 8px 12px 10px 12px;
            font-size: @fontSize12;
            color: @color153;
            font-weight: 400;
            border-top: 0.5px solid #cccccc;
            span{
                margin-right: 26px;
            }
        }
        // 下周更新
        .banner{
            border-radius: 4px;
            padding: 12px 14px 22px 12px;
            text-align: center;
            overflow: hidden;
            img{
                border-radius: 4px;
                width: 100%;
                margin: 0 auto;
            }
        }
    }
    .nextUpdate{
        .module_title{
            padding-bottom: 0;
            border-bottom: 0;
        }
    }
}

</style>

<script>
import mySwiper from "@/components/common/mySwiper/mySwiper.vue";
import { fomatterNum } from "@/assets/js/common.js";
export default {
    name:"featuresCard",
    data(){
        return{
            arr:[]
        }
    },
    props:{
        baseParams:{
            type: Object,
            default:function(){
                return {
                    nowWatch:false,
                    collection:false,
                    noLine:false,
                    isIndex:false
                }
            }
        },
        special:{
            type: Object,
            default:function(){
                return null;
            }
        },
        curPlayVideoId:{
            type: Number
        },
        playType:{
            type: Number,
            default:0
        }
    },
    components:{
        mySwiper
    },
    mounted(){
    },
    methods: {
        fomatterNum,
        /**
         * 立即播放视频
         * type : 1立即观看，2点击具体课程
         * tag: 该专题是否是最新系列
         */
        playVideo:function(id,type,tag,item,index){
            if(type==2){
                const time=item.videoDuration.split(":")[0]*60+item.videoDuration.split(":")[1]*1-1
                sensors.track('VideoClick', {
                    content_id:id,
                    content_title:item.videoTitle,
                    author:'',
                    length_of_time:time,
                    content_topic:this.special.topicTitle,
                    is_tab:true,
                    page_name:this.$route.meta.title,
                    position: index +1

                });
            }else{
                sensors.track('ViewNow', {
                    content_topic:this.special.topicTitle,
                    page_name:this.$route.meta.title
                });

            }
            this.$emit("playCur",id,this.playType);
            window.scrollTo(0, document.getElementsByClassName('wifidetail').offsetTop);
        },
        // 查看全部视频
        watchAll:function(topicId){
            let obj
            const fn_video_id = Number(location.pathname.replace(/[^0-9]/ig,""));//当前视频的id
            const arr=JSON.parse(localStorage.getItem("hfVideo"))
            var newA=[]
            obj= arr.find(item=>{
               if(item.harvardVideos){
                    item.harvardVideos.forEach(i=>{
                                    newA.push(i)
                                })
               }

            }
            )
         obj= newA.find(item=>

              item.fnVideoId===fn_video_id
          )
            const time=obj.videoDuration.split(":")[0]*60+obj.videoDuration.split(":")[1]*1-1
             sensors.track('CheckAll', {
                    content_id:fn_video_id,
                    content_title:obj.videoTitle,
                    author:'',
                    length_of_time:time,
                    content_topic:this.special.topicTitle,
                    page_name:this.$route.meta.title
               });
            this.$emit("playCurTopic",{"topicId":topicId,"curPlayVideoId":this.curPlayVideoId});
        },
        /**
         * gio埋点
         */
        //下期预告点击埋点
        gioClick:function(){
            gio('track', 'hafohome_forecasttopic');//哈佛首页-下期预告
        }
    }

}
</script>